import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import { Modal } from '../../core/services/modal';
import { BaseModal } from '../../shared/components/modals/base-modal/base-modal';
import { ModalOptions } from '../../shared/utils/types';
import { Button } from '../../shared/ui/button/button';
import { OtpModal } from '../../shared/components/modals/otp-modal/otp-modal';
import { InputField } from "../../shared/ui/input-field/input-field";
import { PasswordField } from "../../shared/ui/password-field/password-field";
import { sliders } from '../../shared/utils/constants';
import { LanguageToggle } from "../../shared/components/language-toggle/language-toggle";
import { AuthStore } from '../../core/services/auth-store';
import { OnboardingModal } from '../../shared/components/modals/onboarding-modal/onboarding-modal';


@Component({
  selector: 'app-login',
  imports: [Button, TranslatePipe, RouterLink, InputField, PasswordField, ReactiveFormsModule, CommonModule, LanguageToggle],
  templateUrl: './login.html',
  styleUrl: './login.css'
})
export class Login {

  loginForm: FormGroup;
  otpVerified: boolean = false;
  currentSlide = 0;
  sliders = sliders;
  temporaryPassword: boolean = true;
  email: string = 'z••••@email.com';

  constructor(private modalService: Modal, private fb: FormBuilder,
    private translate: TranslateService, private authStore: AuthStore, private router: Router) {

    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  businessOnboarding() {
    const onBoardingModalOptions: ModalOptions = {
      backdropClosable: false,
      showCancelButton: false,
    };

    this.modalService.open(OnboardingModal, onBoardingModalOptions);
  }


  onLogin() {

    if (this.loginForm.valid) {
      console.log('Login submitted:', this.loginForm.value);
      this.translate.get('login.success').subscribe((message) => {
        console.log(message); // Translated success message
      });

      this.getOtpModal();
      // Add API call or login logic here
    } else {
      // this.usernameControl.setErrors({ apiError: 'Invalid username or password' });
    }
  }

  getOtpModal() {
    const otpModalOptions = {
      backdropClosable: false,
      showCancelButton: true,
      showConfirmButton: true,
      textConfirmButton: 'OTP_MODAL.VERIFY',
      headerIconPath: 'assets/icons/mail.svg',
      title: 'OTP_MODAL.TITLE_EMAIL',
      message: 'OTP_MODAL.MESSAGE_EMAIL',
      email: this.email,

      onSubmitOtp: (isOtpValid: boolean) => {
        this.otpVerified = isOtpValid;
        console.log('OTP validation result:', this.otpVerified);

        this.temporaryPasswordModal();
        if (isOtpValid) {
          this.modalService.close();

          const username = this.loginForm.get('username')?.value;
          const password = this.loginForm.get('password')?.value;

          if (username && password) {
            this.authStore.login({ username, password }).subscribe({
              next: () => {
                console.log('Login successful');
                if (this.temporaryPassword) {
                  this.temporaryPasswordModal();
                } else {
                  this.router.navigate(['/accounts']);
                }
              },
              error: (err) => {
                console.error('Login failed:', err);
                this.temporaryPasswordModal();
              },
            });
          } else {
            console.error('Missing username or password values in login form');
          }
        } else {
          console.log('Invalid OTP');
        }
      },

      onResendCode: () => {
        console.log('Resend code triggered');
        // TODO: call API to resend OTP
      },
    };

    this.modalService.open(OtpModal, otpModalOptions);
  }

  temporaryPasswordModal() {
    const baseModalOptions: ModalOptions = {
      backdropClosable: false,
      showCancelButton: false,
      showConfirmButton: true,
      textConfrimButton: 'LOGIN.CONTINUE',
      size: 'lg',
      headerIconPath: 'assets/icons/info-grey.svg',
      title: 'LOGIN.TEMP_PASSWORD_TITLE',
      message: 'LOGIN.TEMP_PASSWORD_MESSAGE',
      onConfirm: () => {
        console.log('OTP validation result:', this.otpVerified);
        this.modalService.close();
        this.router.navigate(['/change-password'], { queryParams: { from: 'login' } }); //this tells navigated from login to change default password
      },
    };

    this.modalService.open(BaseModal, baseModalOptions);
  }

  forgotPassword() {
    // console.log('Forgot password clicked');
    // Placeholder for forgot password logic (e.g., open modal or navigate)
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.sliders.length;
  }

  prevSlide() {
    this.currentSlide =
      (this.currentSlide - 1 + this.sliders.length) % this.sliders.length;
  }

  getControl(controlName: string): FormControl {
    return this.loginForm.get(controlName) as FormControl;
  }
  
  hasError(name: string): boolean {
    const control = this.getControl(name);
    return control.invalid && (control.touched || control.dirty);
  }
}




// {

// 	"Accept": null,

// 	"Host": "10.6.13.2:2190",

// 	"ChannelId": "01",

// 	"BankId": "01",

// 	"CountryCode": "JOR",

// 	"IP": "",

// 	"DeviceId": "e467fe3f7a16e1b5bc25562b3c17f688ec52cda802c3f9c5cd325bb1ca0934b2",

// 	"Latitude": "0.0",

// 	"Longitude": "0.0",

// 	"Platform": "A",

// 	"MobileModel": "",

// 	"AppVersion": "2.0.1 2507161",

// 	"IsRefreshToken": "true",

// 	"OSVersion": null,

// 	"Language": "EN",

// 	"XForwardedFor": null,

// 	"XRealIP": null

// }
//  {
// 	"Accept": null,
// 	"Host": "10.6.13.2:2190",
// 	"ChannelId": "01",
// 	"BankId": "01",
// 	"CountryCode": "JOR",
// 	"IP": "",
// 	"DeviceId": "e467fe3f7a16e1b5bc25562b3c17f688ec52cda802c3f9c5cd325bb1ca0934b2",
// 	"Latitude": "0.0",
// 	"Longitude": "0.0",
// 	"Platform": "A",
// 	"MobileModel": "",
// 	"AppVersion": "2.0.1 2507161",
// 	"IsRefreshToken": "true",
// 	"OSVersion": null,
// 	"Language": "EN",
// 	"XForwardedFor": null,
// 	"XRealIP": null
// }